export default __webpack_public_path__ + "static/media/ico-restaurante.a7ab1a7c.svg";